<template lang='pug'>
  #navMenu.c-nav.flexD.col-24.justifySpaceBetween.alignItemsCenter(:class="{'ieNav': Common.IEVersion() != -1}")
    .c-nav__logo.cursorPointer(@click="routeTo('homepage')")
      img.block.col-24(:src="img.logo" alt="")
    .c-nav__menu.flexD.flexNoWrap.alignItemsCenter
      .c-nav__menu--btn.cursorPointer(v-for="item in menu" :key="item.id" :class="{'checked' : item.id == navActive}" @click="jumpToScroll(item.id)")
        a {{item.text}}
        .c-nav__menu--pointer

    .c-nav__mobile.alignItemsCenter
      .c-nav__mobile--btn.cursorPointer.relative(:class="{'is-active': menuActive == true}" @click='toggleMenu()')
        p.absolute(v-for="i in 3" :key="i")
      .c-nav__mobile--logo.cursorPointer(@click="jumpToScroll(0)")
        img(:src="img.logo" alt="")

    .c-nav__right.flexD
      .c-nav__language.cursorPointer.relative(@click="stopPropagation($event);toggleLanguageChild()")
        p.relative
          | {{ defaultLanguage }}
          i.absolute(:class="languageActive == true ? 'fa fa-angle-up' : 'fa fa-angle-down'")
        .c-nav__language--select.absolute(:class="{'is-active': languageActive == true}")
          p(v-for="(item, index) in languageList" :key="index" :class="{'is-active': defaultLanguage == item.name}" @click='stopPropagation($event); lang = item.value') {{ item.name }}

    .c-nav__popup(:class="{'is-active': menuActive == true}" @click="menuActive = false")
      .c-nav__popup--items
        .c-nav__popup--item(v-for="item in menu" :key="item.id" :class="{'checked': item.id == navActive}")
          a.c-nav__popup--item--noChild(@click="jumpToScroll(item.id)") {{item.text}}

</template>

<script>
  export default {
    name: 'navMenu',
    data(){
      return{
        img:{
          logo: require('@/assets/img/logo_main.png'),
        },
        menu:[
          { id: 0, text: this.$t('menu.homepage'), key: 'homepage'},
          { id: 1, text: this.$t('menu.business'), key: 'business'},
          { id: 2, text: this.$t('menu.about_us'), key: 'aboutus'},
          { id: 3, text: this.$t('menu.team_work'), key: 'teamwork'},
          { id: 4, text: this.$t('menu.contact_us'), key: 'contactus'},
        ],
        navActive: 0,
        menuActive: false,
        languageList: [
          { name: "中文", value: 'zh_cn'},
          // { name: "English", value: 'en_us'},
          // { name: "Deutsch", value: 'de_de'},
        ],
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
        languageActive: false
      }
    },
    computed: {
      lang: {
        get () {
          return this.$i18n.locale
        },
        set (v) {
          this.languageActive = false
          if (v != this.languageDefault) {
            this.$i18n.locale = v
            this.languageDefault = v
            localStorage.lang = v
            window.location.reload()
          }
        },
      },
      routeName: function() {
        return function(url){
          if (url == '/' + this.$route.name) {
            return true
          }
          return false
        }
      },
      defaultLanguage(){
        let name
        for (var i = 0; i < this.languageList.length; i++) {
          if (this.languageList[i].value == this.languageDefault) {
            name = this.languageList[i].name
          }
        }
        return name
      },
    },
    methods:{
      jumpToScroll(key){
        this.$parent.jumpToScroll(key)
      },
      toggleMenu(){
        this.menuActive = !this.menuActive
      },
      closeLanguageChild(){
        this.languageActive = false
      },
      toggleLanguageChild(){
        this.languageActive = !this.languageActive
        this.menuActive = false
      },
      routeTo(url){
        this.$router.push({
          name: url
        })
      },
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
    },
    created(){}
  }
</script>
